import { combineEpics } from "redux-observable";
import { a as createOrUpdateHypothesisEpicReducer, b as loadMetricsEpicReducer, e as loadAnalysisTemplatesEpicReducer, l as loadHypothesisEpicReducer, g as getExperimentationGroupEpicReducer, q as queryMetricsEpicReducer, f as loadMetricsAnalysisTemplateEpicReducer, h as loadRootFeatureEpicReducer, i as loadAnalysisGroupEpicReducer } from "../../../../../Create.ducks-09e3d573.js";
const rootEpic = combineEpics(
  createOrUpdateHypothesisEpicReducer.epic,
  loadMetricsEpicReducer.epic,
  loadAnalysisTemplatesEpicReducer.epic,
  loadHypothesisEpicReducer.epic,
  getExperimentationGroupEpicReducer.epic,
  queryMetricsEpicReducer.epic,
  loadMetricsAnalysisTemplateEpicReducer.epic,
  loadRootFeatureEpicReducer.epic,
  loadAnalysisGroupEpicReducer.epic
);
export {
  rootEpic
};
//# sourceMappingURL=Create.epics.js.map
